// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.typing-container {
    display: flex;
    gap: 12px;
    justify-content: flex-start;
    animation: fade-in 0.3s ease-out;
}

.typing-avatar {
    width: 32px;
    height: 32px;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 4px;
}

.typing-avatar svg {
    width: 16px;
    height: 16px;
    color: #3B82F6;
}

.typing-bubble {
    background: #f3f4f6;
    color: #1f2937;
    padding: 12px 16px;
    border-radius: 16px;
    border-bottom-left-radius: 6px;
    box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.1);
}

.typing-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.typing-dots {
    display: flex;
    gap: 4px;
}

.typing-dot {
    width: 8px;
    height: 8px;
    background: rgba(59, 130, 246, 0.6);
    border-radius: 50%;
    animation: typing-bounce 1.4s infinite ease-in-out;
}

.typing-text {
    font-size: 12px;
    color: #6b7280;
}

@keyframes typing-bounce {
    0%, 60%, 100% {
        transform: translateY(0);
    }
    30% {
        transform: translateY(-10px);
    }
}

@keyframes fade-in {
    0% {
        opacity: 0;
        transform: scale(0.95);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/TypingIndicator.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ","sourcesContent":[".typing-container {\r\n    display: flex;\r\n    gap: 12px;\r\n    justify-content: flex-start;\r\n    animation: fade-in 0.3s ease-out;\r\n}\r\n\r\n.typing-avatar {\r\n    width: 32px;\r\n    height: 32px;\r\n    background: rgba(59, 130, 246, 0.1);\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n    margin-top: 4px;\r\n}\r\n\r\n.typing-avatar svg {\r\n    width: 16px;\r\n    height: 16px;\r\n    color: #3B82F6;\r\n}\r\n\r\n.typing-bubble {\r\n    background: #f3f4f6;\r\n    color: #1f2937;\r\n    padding: 12px 16px;\r\n    border-radius: 16px;\r\n    border-bottom-left-radius: 6px;\r\n    box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.typing-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.typing-dots {\r\n    display: flex;\r\n    gap: 4px;\r\n}\r\n\r\n.typing-dot {\r\n    width: 8px;\r\n    height: 8px;\r\n    background: rgba(59, 130, 246, 0.6);\r\n    border-radius: 50%;\r\n    animation: typing-bounce 1.4s infinite ease-in-out;\r\n}\r\n\r\n.typing-text {\r\n    font-size: 12px;\r\n    color: #6b7280;\r\n}\r\n\r\n@keyframes typing-bounce {\r\n    0%, 60%, 100% {\r\n        transform: translateY(0);\r\n    }\r\n    30% {\r\n        transform: translateY(-10px);\r\n    }\r\n}\r\n\r\n@keyframes fade-in {\r\n    0% {\r\n        opacity: 0;\r\n        transform: scale(0.95);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
